import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {deleto, get, patch, post, puto} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

const successKeys = [
    actions.PRICE_LEVEL_CREATE_SUCCESS,
    actions.PRICE_LEVEL_CREATE_SUCCESS,
    actions.PRICE_LEVEL_READ_SUCCESS,
    actions.PRICE_LEVEL_READ_ALL_SUCCESS,
    actions.PRICE_LEVEL_UPDATE_SUCCESS,
    actions.PRICE_LEVEL_ARCHIVE_SUCCESS,
    actions.PRICE_LEVEL_DELETE_SUCCESS,
];
const errorKeys = [
    actions.PRICE_LEVEL_CREATE_ERROR,
    actions.PRICE_LEVEL_CREATE_ERROR,
    actions.PRICE_LEVEL_READ_ERROR,
    actions.PRICE_LEVEL_READ_ALL_ERROR,
    actions.PRICE_LEVEL_UPDATE_ERROR,
    actions.PRICE_LEVEL_ARCHIVE_ERROR,
    actions.PRICE_LEVEL_DELETE_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.PRICE_LEVEL_CREATE_SUCCESS:
            return t`The price level is created.`;
        case actions.PRICE_LEVEL_UPDATE_SUCCESS:
            return t`The price level is updated.`;
        case actions.PRICE_LEVEL_ARCHIVE_SUCCESS:
            return action.isArchived ? t`The price level is deactivated.` : t`The price level is activated.`;
        case actions.PRICE_LEVEL_DELETE_SUCCESS:
            return t`The price level is deleted.`;
        default:
            return null;
    }
};

// Create price level
function* createPriceLevelRequest() {
    yield takeEvery(actions.PRICE_LEVEL_CREATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                const response = yield call(post, '/price_levels', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PRICE_LEVEL_CREATE_SUCCESS,
                    priceLevel: data.price_level,
                });
            });
    });
}

// Read price level list
function* readPriceLevelsRequest() {
    yield takeEvery(actions.PRICE_LEVEL_READ_ALL_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                const response = yield call(get, '/price_levels', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PRICE_LEVEL_READ_ALL_SUCCESS,
                    priceLevels: data.price_levels,
                    pagination: data.paging,
                });
            });
    });
}

// Read price level (by id)
function* readPriceLevelRequest() {
    yield takeEvery(actions.PRICE_LEVEL_READ_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/price_levels/${id}`, null, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PRICE_LEVEL_READ_SUCCESS,
                    priceLevel: data.price_level,
                });
            });
    });
}

// Update price level (by id)
function* updatePriceLevelRequest() {
    yield takeEvery(actions.PRICE_LEVEL_UPDATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                const response = yield call(puto, `/price_levels/${id}`, request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PRICE_LEVEL_UPDATE_SUCCESS,
                    priceLevel: data.price_levels,
                });
            });
    });
}

// Archive price level (by id)
function* archivePriceLevelRequest() {
    yield takeEvery(actions.PRICE_LEVEL_ARCHIVE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                yield call(patch, `/price_levels/${id}`, request, context);

                // OK
                yield put({
                    type: actions.PRICE_LEVEL_ARCHIVE_SUCCESS,
                    isArchived: request.is_archived,
                });
            });
    });
}

// Archive price level (by id)
function* deletePriceLevelRequest() {
    yield takeEvery(actions.PRICE_LEVEL_DELETE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/price_levels/${id}`, null, context);
                yield put({ type: actions.PRICE_LEVEL_DELETE_SUCCESS });
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(createPriceLevelRequest),
        fork(readPriceLevelsRequest),
        fork(readPriceLevelRequest),
        fork(updatePriceLevelRequest),
        fork(archivePriceLevelRequest),
        fork(deletePriceLevelRequest),
    ]);
}
